export default __webpack_public_path__ + "images/process_5.svg?15323f2bcdf7224a795c252aa5c8e8d4";